import { EmployeesList } from './modules/EmployeesList'

export const Employees = () => {
  return <EmployeesList />
}
